export default __webpack_public_path__ + "static/media/icon_messagesRequiringAction.e044b445.svg";